"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDepositCount = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var user_1 = require("../user");
var useDepositCount = function () {
    var isAuth = (0, user_1.useIsAuthorized)();
    var _a = (0, useQuery_1.useQuery)({
        canRender: isAuth,
        path: keys_1.DEPOSIT_SUCCESS_COUNT,
        revalidateOnMount: true,
    }), data = _a.data, error = _a.error, isLoading = _a.isLoading;
    return (0, react_1.useMemo)(function () {
        var _a;
        return ({
            data: isAuth ? ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.count) || 0 : 0,
            isLoading: isLoading,
            error: error,
        });
    }, [data, isLoading, error, isAuth]);
};
exports.useDepositCount = useDepositCount;
